import { WebUrl } from "shared-web/lib/webUrl"

export const ANALYTICS_DASHBOARDS_PATHNAME = "/pos/analytics/dashboards"

export function analyticsSummary(): WebUrl {
  return {
    pathname: `${ANALYTICS_DASHBOARDS_PATHNAME}/summary-v1`,
  }
}

export function analyticsSummaryV2(): WebUrl {
  return {
    pathname: `${ANALYTICS_DASHBOARDS_PATHNAME}/summary-v2`,
  }
}

export function reportBuilder(): WebUrl {
  return {
    pathname: "/pos/analytics/build-report",
  }
}

export function reportBuilderReport(identifier?: string): WebUrl {
  return {
    pathname: `/pos/analytics/build-report/report/${encodeURIComponent(identifier ?? "")}`,
  }
}
